<template>
  <!-- 预览文件 gbq5 文件 -->
  <div class="preview">
    <template v-if="dataFetched">
      <!-- 左侧树形菜单 -->
      <div class="nav-tree tree-content" v-if="treeData.length" :style="{height: tableHeight - 5 + 'px'}">
        <ul :key="refreshTreeIndex">
          <li v-for="(item, idx) in treeData"
              v-show="item.show"
              :id="item.id"
              :pid="item.pIdKey"
              :style="{paddingLeft: item.level * 18 + 'px'}"
              :key="'syb_nav_' + idx">
            <p :class="item.leaf ? 'leaf': ''">
              <template v-if="!item.leaf">
                <i :class="!item.childrenHide ? 'fold' : 'unfold'"
                   @click="switchFold(item, 'tree')">
                </i>
              </template>
              <a  href="javascript: void(0);" @click.stop="treeNodeClick(item, 'tree')"
                  :title="item.name"
                  :class="['level', suffix === 'gbq5' || suffix === 'gbq6' || suffix === 'gbq7'? 'level_' + item.nodeType : 'level_normal' , item.path === treeActive ? ' active' : '']">
                {{item.name}}
              </a>
            </p>
          </li>
        </ul>
      </div>

      <!-- 主数据区域 -->
      <div :class="['preview-main' ,treeData.length ? 'mg-l-242' : '']" :style="{height: tableHeight + 'px', position: treeData.length ? 'relative' : 'inherit'}">

        <!-- tab切换区域 -->
        <tab-title :list="tabList" :active="currentTab" @change="changeTab">
          <multiple-select v-if="hasColorFilter" :list="colorList"
                           type="selectColor"
                           name="selectColorForPreview"
                           class="select-color"
                           @change="colorFilter"
                           :selected="colorSelectedArr"
                           :refresh-index="refreshColorSelect">

          </multiple-select>
          <div class="multiselect select-color remark-tooltip" v-if="['gbq5', 'gbq6', 'gbq7'].includes(suffix) && !previewShare && ['3', '4', '6'].includes(currentTab)">
            <a href="javascript: void(0);" class="multiselect-btn major-btn-norm f-cb background-white">
              <img src="../../assets/images/preview/edit.png" alt="">
              <span>添加批注</span>
            </a>
            <div class="absolute remark-content">
              请将鼠标定位在任意{{currentTab === '3' ? '清单' : '一'}}行上<br/>
              <strong style="color: #1A6DCD;">点击右键</strong>
              即可添加批注！</div>
          </div>
        </tab-title>
        <!--, paddingLeft: subTreeData.length ? '170px' : '10px'-->
        <div class="table-wrapper" :style="{height: (tableHeight - 48) + 'px'}" style="position: inherit;padding-left: 10px;">

          <!-- 内容区域的树形菜单 -->
          <div class="nav-tree" v-if="subTreeData.length"  style="position: inherit;float: left;">
            <div class="nav-tree__inner">
              <ul :key="refreshSubTreeIndex">
                <li v-for="(item, idx) in subTreeData"
                    v-show="item.show"
                    :id="item.id"
                    :pid="item.pIdKey"
                    :style="{paddingLeft: item.level * 18 + 'px'}"
                    :key="'syb_nav_' + idx">
                  <p :class="item.leaf ? 'leaf': ''">
                    <template v-if="!item.leaf">
                      <i :class="!item.childrenHide ? 'fold' : 'unfold'"
                         @click="switchFold(item, 'subTree')">
                      </i>
                    </template>
                    <a  href="javascript: void(0);" @click.stop="treeNodeClick(item, 'subTree')"
                        :class="item.path === subTreeActive ? 'active' : ''"
                        :title="item.name">
                      {{item.name}}
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <!-- 内容区域 表格 -->
          <div class="table-cont" ref="tableCont">
            <div class="table-box" ref="tableBox" :key="refreshTableIndex">
              <div class="no_data" v-if="!tableData.length && !loading">
                <img src="../../assets/images/nodatanothere.png" alt="">
                <div>该表格数据不存在</div>
              </div>
              <template v-else>
                <tr v-for="(trItem, idx) in tableData"
                    v-show="trItem.show"
                    :pid="trItem.pid"
                    :id="trItem.id"
                    :path="trItem.path"
                    :style="{top: scrollTop + ' px'}"
                    :class="(lastShowIndex === idx && idx !== 0) ? 'last-line' : ''"
                    :key="'preview_tr_' + idx">
                  <td v-for="(tdItem, index) in trItem.content"
                      @contextmenu="tdMouseEnter(idx,index, trItem, tdItem)"
                      :colspan="tdItem.colspan || 1"
                      :rowspan="tdItem.rowspan || 1"
                      :style-computed="tdItem | computedStyle(trItem, idx, index, scrollTop, scrollLeft, fixedColumnCount)"
                      :style-original="tdItem.style"
                      :style="tdItem | computedStyle(trItem, idx, index, scrollTop, scrollLeft, fixedColumnCount)"
                      :class="[trItem.fixedTh && idx === 0 ? 'fixed-th' : '', trItem.fixedTd && index < fixedColumnCount ? (idx > 0 ? 'fixed-td-left' : 'fixed-th-left') : '', ]"
                      :key="'preview_tr_' + idx + '_td_' + index">
                    <div class="f-cb" :style="{paddingLeft: (index === 0 && (suffix === 'gbq5' || suffix === 'gbq6' || suffix === 'gbq7')) ? trItem.level * 15 + 'px' : ''}">
                      <template v-if="!trItem.leaf && index === 0">
                        <i :class="[!trItem.childrenHide ? 'fold' : 'unfold']"
                           @click="switchFold(trItem, 'table')">
                        </i>
                      </template>
                      <p v-if="!tdItem.isCheckbox" v-html="tdItem.content"></p>
                      <input v-if="tdItem.isCheckbox" type="checkbox" :checked="+tdItem.content === 1">
                      <template v-if="trItem.guid && index == trItem.index">
                        <i :class="trItem.comment && !/^\s+$/.test(trItem.comment) ? 'remarked' : ''"
                           @click.stop=""
                           :key="'remark_tr_' + idx + '_td_' + refreshRemarkIndex">
                          <!-- 查看 批注 -->
                          <!--<div class="remark-box show" v-show="remark.type === 'show' && remark.row == idx && remark.column === index">-->
                          <div class="remark-box show" v-show="remark.type === 'show' && remark.row == idx">
                            <div class="remark-box_inner">
                              {{trItem.comment}}
                            </div>
                          </div>
                          <!-- 添加/修改 批注 -->
                          <!--<div class="remark-box edit" v-show="(remark.type === 'add' || remark.type === 'edit') && remark.row == idx && remark.column === index">-->
                          <div class="remark-box edit" v-show="(remark.type === 'add' || remark.type === 'edit') && remark.row == idx">
                            <!--<textarea :id="'remark_' + idx + '_' + index" :value="trItem.comment" maxlength="100"></textarea>-->
                            <textarea :id="'remark_' + idx" :value="trItem.comment" maxlength="100"></textarea>
                          </div>
                        </i>
                      </template>
                    </div>
                  </td>
                </tr>
              </template>
            </div>
          </div>
          <!-- 右键菜单 -->
          <ul ref="contextMenu" class="contextMenu" v-show="contextMenu.show > (previewShare ? 0 : -1)" :style="{top: contextMenu.top + 'px', left: contextMenu.left + 'px'}">
            <template v-if="previewShare">
              <li @click.stop="remarkHandle('show')" class="cursor-pointer">
                查看批注
              </li>
            </template>
            <li @click.stop="remarkHandle('add')" :class="isInfoPrivilege?'cursor-not-allowed disable':'cursor-pointer'" v-else-if="contextMenu.show === 0">
              添加批注
            </li>
            <template v-else>
              <li @click.stop="remarkHandle('show')" class="cursor-pointer">
                查看批注
              </li>
              <li @click.stop="remarkHandle('edit')" :class="isInfoPrivilege?'cursor-not-allowed disable':'cursor-pointer'">
                编辑批注
              </li>
              <li @click.stop="remarkHandle('delete')" :class="isInfoPrivilege?'cursor-not-allowed disable':'cursor-pointer'">
                删除批注
              </li>
            </template>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import service from '@/assets/service'
import TabTitle from '../common/TabTitle'
import {capitalize, clone} from '@/assets/utils'
import {MultipleSelect} from '@/components/common'
import { throttle } from 'throttle-debounce'
import {mapState} from 'vuex'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
// 2: 项目信息; 3: 分部分项; 4: 措施项目; 5: 其他项目; 6: 人材机汇总; 8: 造价分析; 9: 工程概况; 10: 费用汇总;
export default {
  name: 'PreviewGbq5',
  filters: {
    // 1. 计算 th、td 行内样式
    computedStyle (item, trItem, trIndex, index, scrollTop, scrollLeft, fixedColumnCount) {
      let sty = item.style || ' '
      if (trItem.fixedTh && trIndex === 0) {
        sty += '; top:' + scrollTop + 'px; '
      }
      if (trItem.fixedTd && index < fixedColumnCount) {
        sty += '; left:' + scrollLeft + 'px; '
      }
      if (trIndex === 0) {
        // console.log(sty)
      }
      const reg = /background:\s*(#[a-f]{6})/i
      const matchArr = reg.exec(sty)
      let tempSty = sty
      if (matchArr && matchArr[1]) {
        sty = sty.substring(0, sty.indexOf(matchArr[1]))
        sty += matchArr[1] + '; '
        sty += tempSty.substring(tempSty.indexOf(matchArr[1]) + matchArr[1].length)
      }
      return sty
    }
  },
  props: {
    previewShare: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: () => {}
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      projectId: '', // 工程id
      subTreeId: '', // 子树id
      nodeType: -1, // 工程类型 0标段,1单项工程,2单位工程
      treeData: [], // 左侧树型菜单 数据
      subTreeData: [], // 右 数据里 树型菜单 数据
      subTreeActive: '',
      treeActive: '',
      tabList: [],
      currentTab: '', // 0:项目结构, 1: 表的标题, 2:项目信息, 3:分部分项、预算书直接费、预算书、实体项目, 4:措施项目, 5:其他项目,6:人材机汇总, 8:造价分析, 9:工程概况, 10:费用汇总、其他费用, 11:独立费
      tableData: [],
      tableDataArr: [],
      colorList: [], // 可选 颜色列表
      colorSelected: {}, // 已选择的颜色列表
      colorSelectedArr: [], // 已选择的颜色列表
      showListFilterByColor: {},
      dataFetched: false,
      fixedColumnCount: 0,
      scrollTop: 10,
      scrollLeft: 10,
      contextMenu: {
        show: -1, // 显示右键菜单 -1: 不显示; 1: 显示添加批注; 其他: 显示查看、编辑、删除批注
        left: 0,
        top: 0,
        startLeft: 0,
        startTop: 0,
        scrollTop: 0, // 显示 右键菜单时 滚动条 scrollTop
        scrollLeft: 0, // 显示 右键菜单时 滚动条 scrollLeft
        fixedTd: false
      },
      remark: {
        row: -1,
        column: -1,
        guid: '',
        comment: '',
        code: '',
        name: '',
        pending: false, // 正在发送请求
        type: '' // add/edit、show
      },
      bgColor: {
        '#FF9393': '红色',
        '#E4FED8': '绿色 ',
        '#F8845B': '橙色',
        '#FEFD97': '黄色',
        '#81A6FB': '深蓝色',
        '#D9A5EC': '淡紫色',
        '#A0D4FB': '亮蓝色',
        '#FFDE7D': '深黄色'
      },
      lastShowIndex: 0,
      refreshColorSelect: 0,
      refreshTableIndex: 0, // 刷新 表格 数据
      refreshTreeIndex: 0, // 刷新 树 数据
      refreshSubTreeIndex: 0, // 刷新 子树 数据
      refreshRemarkIndex: 0,
      tableBoxScrollEvent: null, // 表格滚动条滚动事件
      contextmenuEvent: null, // 右键菜单 事件
      documentClickEvent: null,
      loading: false
    }
  },
  computed: {
    ...mapState({
      previewFileChange: state => state.config.previewFileChange
    }),
    filePath () {
      let str = ''
      if (this.query.path) {
        str = this.query.path // 修复GBQ6、GBQ5 文件名称含有%时，预览tab切换控制台报错，不能预览的问题
        // str = decodeURIComponent(this.query.path)
      }
      return str
    },
    hasColorFilter () {
      const currentTab = +this.currentTab
      return currentTab === 3 || currentTab === 4 || currentTab === 6
    },
    isInfoPrivilege () {
      return this.$route.query.privilege === 'view' || this.$route.query.recordedProjectId
    }
  },
  beforeDestroy (){
    this.initEvent()
  },
  mounted () {
    console.log(this.$route.query)
    this.initEvent(true)
    const otherHeight = 45 + 23 + 15
    this.setTableHeight(otherHeight)
    // 窗口大小改变时 触发this.$route.query.recordedProjectId
    this.resizeHandle.resize(() => {
      this.setTableHeight(otherHeight)
    })
    this.getFileFormation()
    // this.changeTab({value: 3})
  },
  methods: {
    // 初始化 表格区域滚动事件
    initEvent (init) {
      setTimeout(() => {
        const tableBox = this.$refs.tableBox
        const tableCont = this.$refs.tableCont
        if (tableBox && this.tableBoxScrollEvent) {
          off(tableBox, 'scroll')
          this.tableBoxScrollEvent = null
        }
        if (this.contextmenuEvent) {
          off(tableCont, 'contextmenu')
          this.contextmenuEvent = null
        }
        if (this.documentClickEvent) {
          off(document, 'click')
          this.documentClickEvent = null
        }
        if (!init) return
        on(tableBox, 'scroll', this.tableBoxScrollEvent = throttle(10, () => {
          if (tableBox) {
            this.scrollTop = tableBox.scrollTop
            this.scrollLeft = tableBox.scrollLeft
            let left = this.contextMenu.startLeft
            if (!this.contextMenu.fixedTd) {
              left += this.contextMenu.scrollLeft - this.scrollLeft
            }
            this.contextMenu.left = left
            this.contextMenu.top = this.contextMenu.startTop + (this.contextMenu.scrollTop - this.scrollTop)
          }
        }))
        // 注册 鼠标右键 事件监听
        on(tableCont, 'contextmenu', this.contextmenuEvent = (e) => {
          e = e || window.event
          // e.stopPropagation();
          // e.preventDefault();
          if (e.preventDefault) {
            e.preventDefault()
          } else {
            e.returnValue = false
          }
          if (e.stopPropagation) {
            e.stopPropagation()
          } else {
            e.cancelBubble = false
          }
          this.remark.type = ''

          let _x = e.clientX || e.x
          let _y = e.clientY || e.y
          if (this.treeData.length) {
            _x -= 232
            _y -= 95
          }
          let comment = this.remark.comment || ''
          if (this.remark.guid !== '') {
            comment.replace(/^\s+/, '')
            comment.replace(/\s+$/, '')
            this.contextMenu.show = comment.length // 如果之前有批注内容 则 右键菜单显示 查看、编辑、删除批注; 否则显示 添加批注
            this.contextMenu.left = _x
            this.contextMenu.top = _y
            // this.contextMenu.startLeft = left;
            // this.contextMenu.startTop = top;
            // this.contextMenu.scrollTop = this.scrollTop;
            // this.contextMenu.scrollLeft = this.scrollLeft;
          } else {
            this.contextMenu.show = -1
          }
        })

        on(document, 'click', this.documentClickEvent = (e) => {
          this.contextMenu.show = -1
          switch (this.remark.type) {
            case 'show':
              this.clearRemark()
              break
            case 'add':
            case 'edit':
              // const textarea = document.getElementById('remark_' + this.remark.row + '_' + this.remark.column)
              const textarea = document.getElementById('remark_' + this.remark.row)
              if (textarea) {
                let comment = textarea.value
                comment.replace(/^\s+/, '')
                comment.replace(/\s+$/, '')
                if (this.remark.type === 'add' && comment === '') {
                  this.clearRemark()
                  return
                }
                this.updateRemark(comment)
              }
              break
            default:
          }
        })
      }, 500)
    },
    // 1. 获取 预览文件组成
    getFileFormation () {
      console.log(this.query.path)
      console.log('====================')
      let params = Object.assign({}, this.query)
      // params.path = params.path.substring(0, params.path.lastIndexOf('/'))
      // params.path += '/' + params.fileName
      // console.log(params)
      // console.log('----------------')
      switch (this.suffix) {
        case 'gbq5': // 深度预览 gbq5 文件
        case 'gbq6': // 深度预览 gbq6 文件
        case 'gbq7': // 深度预览 gbq6 文件
        case 'gbq6jy': // 深度预览 gbq6 文件 - 高教版
        case 'gbq6xs': // 深度预览 gbq6 文件 - 高教版
          this.refreshColorSelect++
          let type = 'getFileFormation'
          // 预览分享的计价文件
          if (this.previewShare) {
            type += 'Share'
          }
          // 备案
          if (this.$route.query.recordedProjectId) {
            type = 'getRecordFileFormation'
            params.projectId = this.$route.query.recordedProjectId
          }
          this.loading = true
          console.log(this.previewShare)
          console.log(type)
          service.preview[type](params).then((data) => {
            this.handleRequest(data)
          }).catch((e) => {
            console.log(e)
            this.$message.error('请求失败')
          })
          break
        default:
          let isRecord
          if (this.$route.query.recordedProjectId) {
            isRecord = true
            params.projectId = this.$route.query.recordedProjectId
          }
          service.preview.previewFirst(params, isRecord).then((data) => {
            this.handleRequest(data)
          }).catch((e) => {
            console.log(e)
            this.$message.error('请求失败')
          })
      }
    },
    // 1.1 处理返回的数据
    handleRequest (data, changeType) {
      this.clearData(changeType)
      const tableBox = this.$refs.tableBox
      if (tableBox && tableBox.scrollTo) {
        tableBox.scrollTo(0, 0)
      } else if (tableBox) {
        // scrollTo 兼容ie
        if (tableBox.scrollTop !== undefined) { tableBox.scrollTop = 0 }
        if (tableBox.scrollLeft !== undefined) { tableBox.scrollLeft = 0 }
      }
      if (+data.code === 200 && data.data) {
        // console.log(data.data)
        let {tab, tree, table, subtree, color} = data.data
        // 是否游离工程
        if (tree){
          this.projectId = '0'
          this.nodeType = '0'
        }
        // 组装 顶部 tab
        if (tab && (!changeType || changeType === 'tree')) {
          const tabList = tab.split(',')
          tabList.forEach((item, idx) => {
            const itemArr = item.split(':')
            if (itemArr.length > 1) {
              this.$set(this.tabList, idx, {value: itemArr[0], name: itemArr[1]})
              if (idx === 0) {
                if (!(changeType && changeType === 'tab')) {
                  this.currentTab = itemArr[0]
                }
              }
            }
          })
        }
        try {
          if (color) {
            const colors = JSON.parse(color)
            colors.forEach((val) => {
              const COLOR = capitalize(val, false, true)
              if (this.bgColor[COLOR]) {
                this.$set(this.colorList, this.colorList.length, {value: COLOR, label: this.bgColor[COLOR]})
              }
            })
          }
          let tableDataArr = []
          if (!table) { table = '[]' }
          if (!tree) { tree = '[]' }
          if (table) {
            tableDataArr = JSON.parse(table)
            // console.log(tableDataArr)
            let leafMaxLevel = tableDataArr.length // 表格数据最大层级数
            switch (this.currentTab + '') {
              case '3': // 3:分部分项、预算书直接费、预算书、实体项目, 4:措施项目
              case '4':
                this.fixedColumnCount = 3
                break
              case '6': // 6:人材机汇总
                this.fixedColumnCount = 2
                break
              default:
                this.fixedColumnCount = 0
            }
            // switch (this.suffix) {
            //   case 'gbq5':
            //     break
            //   default:
            //
            // }
            this.tableDataArr = tableDataArr
            switch (this.suffix) {
              case 'gbq5':
              case 'gbq6':
              case 'gbq7':
              case 'gbq6jy': // 高教版
              case 'gbq6xs': // 高教版
                // console.log(leafMaxLevel)
                // console.log(this.tableDataArr)
                if (leafMaxLevel) {
                  // console.log(JSON.stringify(this.tableDataArr))
                  this.formationTableData(0, leafMaxLevel, this.tableDataArr, {})
                  // this.formationTableData2(0, leafMaxLevel, this.tableDataArr[0], {})
                  // this.tableData = tableDataArr[0]
                }
                break
              default:
                if (leafMaxLevel > 0) {
                  leafMaxLevel = 1
                  this.tableDataArr.forEach((trItem) => {
                    trItem.forEach((tdItem, idx) => {
                      trItem[idx] = this.formationTd(tdItem)
                    })
                    this.$set(this.tableData, this.tableData.length, {
                      content: trItem,
                      show: true,
                      level: 1,
                      leaf: true
                    })
                  })
                } else {
                  this.tableData = []
                }
            }
          }
          if (tree && changeType !== 'tree') {
            // console.log(JSON.parse(tree))
            // this.treeData = JSON.parse(tree)
            this.formationTree(JSON.parse(tree), 'tree')
          }
          if (subtree && changeType !== 'subTree') {
            this.formationTree(JSON.parse(subtree), 'subTree')
          }
          // console.log(this.subTreeData)
        } catch (e) {
          console.log(e)
        }
        this.dataFetched = true
        this.loading = false
        this.refreshColorSelect++
        if (!changeType || changeType === 'tree' || changeType === 'tab') {
          this.initEvent(true)
        }
        // console.log(this.currentTab)
        // console.log(this.tabList)
        // console.log(this.treeData)
        // console.log(this.tableData)
        // if (changeType) return
        // setTimeout(() => {
        //   this.nodeType = 2
        //   this.projectId = 33
        //   this.changeTab({value: 3})
        // }, 500)
      } else {
        this.$message.error('文件不存在')
      }
    },
    // 1.2 组装表格展示数据
    formationTableData (level, leafMaxLevel, arr, parent) {
      const newArr = JSON.parse(JSON.stringify(arr))
      let indexMap = {}
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].length; j++) {
          let item = arr[i][j]
          indexMap[item.id] = [i, j]
        }
      }
      for (let i = arr.length - 1; i > 0; i--) {
        for (let j = 0; j < arr[i].length; j++) {
          if (indexMap[arr[i][j].pid]) {
            const [one, two] = indexMap[arr[i][j].pid]
            if (newArr[one][two].children) {
              newArr[one][two].children.push(newArr[i][j])
            } else {
              newArr[one][two].children = [newArr[i][j]]
            }
          }
        }
      }
      this.tableData = this.treeToList(newArr[0])
    },
    treeToList (tree, result = [], level = 0, parent = {}) {
      tree.forEach(node => {
        let nowTr = node
        if (nowTr.content && nowTr.content.length) {
          nowTr.content.forEach((tdItem, idx) => {
            nowTr.content[idx] = this.formationTd(tdItem)
          })
          if (!nowTr.leaf) {
            // 强制设置 有子菜单的行 第一列 文字居左
            if (!nowTr.content[0].style) {
              nowTr.content[0].style = '; text-align: left; '
            } else {
              nowTr.content[0].style += '; text-align: left; '
            }
          }
        }
        if (parent.id === undefined || parent.id === nowTr.pid) {
          let fixedTh = this.fixedColumnCount || false
          let fixedTd = this.fixedColumnCount || false
          let path = parent.path ? parent.path + '-' : ''
          Object.assign(nowTr, {
            path: path + nowTr.id,
            fixedTh, // 固定表头
            fixedTd, // 固定列
            level,
            childrenHide: false,
            show: true
          })
          result.push(nowTr)
        }
        node.children && this.treeToList(node.children, result, level + 1, node)
      })
      return result
    },
    // 1.2 组装表格展示数据
    formationTableData2 (level, leafMaxLevel, arr, parent) {
      let path = parent.path ? parent.path + '-' : ''
      const dealData = (item) => {
        let nowTr = item
        if (nowTr.content && nowTr.content.length) {
          nowTr.content.forEach((tdItem, idx) => {
            nowTr.content[idx] = this.formationTd(tdItem)
          })
          if (!nowTr.leaf) {
            // 强制设置 有子菜单的行 第一列 文字居左
            if (!nowTr.content[0].style) {
              nowTr.content[0].style = '; text-align: left; '
            } else {
              nowTr.content[0].style += '; text-align: left; '
            }
          }
        }
        if (parent.id === undefined || parent.id === nowTr.pid) {
          let fixedTh = this.fixedColumnCount || false
          let fixedTd = this.fixedColumnCount || false
          const obj = Object.assign(nowTr, {
            path: path + nowTr.id,
            fixedTh, // 固定表头
            fixedTd, // 固定列
            level,
            childrenHide: false,
            show: true
          })
          this.$set(this.tableData, this.tableData.length, obj)
        }
        if (!item.leaf) {
          const subLevel = level + 1
          if (subLevel < leafMaxLevel) {
            this.formationTableData(subLevel, leafMaxLevel, this.tableDataArr[subLevel], this.tableData[this.tableData.length - 1])
          }
        }
      }
      for (let i = 0; i < arr.length; i++) {
        dealData(arr[i])
      }
    },
    // 1.3 组装表格内 左侧树形菜单
    formationTree (arr, type) {
      let tempObj = {}
      if (arr.length) {
        let rootNode = null
        let findRoot = false
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].pIdKey === '') {
            findRoot = true
            rootNode = Object.assign(arr[i], {level: 0, leaf: false, path: arr[0].id, childrenHide: false, show: true})
            break
          }
        }
        if (!findRoot) {
          rootNode = Object.assign(arr[0], {level: 0, leaf: false, path: arr[0].id, childrenHide: false, show: true})
        }
        const resultArr = [rootNode]
        arr.forEach((item, idx) => {
          if (!findRoot && idx === 0) {
            return
          }
          if (item.pIdKey !== '') {
            if (!tempObj[item.pIdKey]) {
              tempObj[item.pIdKey] = [item]
            } else {
              tempObj[item.pIdKey].push(item)
            }
          }
        })
        // console.log(JSON.stringify(tempObj))
        // 组装数组
        const findChildren = function (id, parent) {
          // console.log(id)
          tempObj[id].forEach((item) => {
            let path = parent.path ? parent.path + '-' : ''
            const leaf = !(item.id in tempObj)
            const nowNode = Object.assign(item, {level: parent.level + 1, leaf, path: path + item.id, childrenHide: false, show: true})
            resultArr.push(nowNode)
            if (!leaf) {
              findChildren(nowNode.id, nowNode)
            }
          })
        }
        if (rootNode.id in tempObj) {
          findChildren(rootNode.id, rootNode)
        }
        // console.log(tempObj)
        // console.log(JSON.stringify(resultArr))
        // this.subTreeData = resultArr
        console.log(resultArr)
        console.log('111111111111111111111111111111')
        this[type + 'Data'] = resultArr
        if (resultArr.length) {
          this[type + 'Active'] = resultArr[0].path
        }
      }
    },
    // 1.4 组装 表格 单元格
    formationTd (item) {
      const tdItem = item
      let colspan = 1 // 合并列
      let rowspan = 1 // 合并行
      let style = ''
      let isCheckbox = false
      if (tdItem.style) {
        if (tdItem.style.indexOf('STYLE_VERTICAL_COMBINE_TWO') > -1) {
          rowspan = 2
        }
        if (tdItem.style.indexOf('STYLE_HORIZONTAL_COMBINE_TWO') > -1) {
          colspan = 2
        }
        if (tdItem.style.indexOf('STYLE_HORIZONTAL_COMBINE_THREE') > -1) {
          colspan = 3
        }
        if (tdItem.style.indexOf('STYLE_HORIZONTAL_COMBINE_FOUR') > -1) {
          colspan = 4
        }
        if (tdItem.style.indexOf('STYLE_INFO_HEADER') > -1) {
          style += ' font-weight: bold; '
        }
        if (tdItem.style.indexOf('STYLE_HEADER') > -1) {
          style += ' text-align: center; vertical-align: middle; '
        }
        // 当前单元格显示为 复选框
        if (tdItem.style.indexOf('STYLE_CHECK') > -1) {
          isCheckbox = true
        }
      }
      if (tdItem.span) {
        const spanStr = tdItem.span + ''
        if (spanStr.indexOf('colspan') > -1 && colspan === 1) {
          colspan = spanStr.replace(/colspan\s*:\s*/, '')
        } else if (spanStr.indexOf('rowspan') > -1 && rowspan === 1) {
          rowspan = spanStr.replace(/rowspan\s*:\s*/, '')
        }
      }
      tdItem.isCheckbox = isCheckbox
      tdItem.rowspan = rowspan + ''
      tdItem.colspan = colspan + ''
      if (style) {
        tdItem.style = style
      }
      return tdItem
    },
    // 2.查询数据
    fetchData (changeType) {
      this.refreshColorSelect++
      let type = ''
      switch (this.suffix) {
        case 'gbq5': //  gbq5文件; 或分享的gbq5文件
        case 'gbq6': //  gbq6文件; 或分享的gbq6文件
        case 'gbq7': //  gbq6文件; 或分享的gbq6文件
        case 'gbq6jy': // gbq6文件; 或分享的gbq6文件 - 高教版
        case 'gbq6xs': // gbq6文件; 或分享的gbq6文件 - 高教版
          type = 'Deep'
          if (changeType === 'subTree') {
            type = 'DeepSubTree'
          }
          // 预览分享的计价文件
          if (this.previewShare) {
            type += 'Share'
          } else if (+this.query.fileType !== 1) {
            type = ''
          }
          break
        default:
          type = 'Valuation'
      }
      if (type) {
        let obj = this.query
        obj.tableType = (changeType === 'tree' || !changeType) ? -1 : this.currentTab
        obj.projectId = this.projectId || '-1'
        if (changeType === 'subTree') {
          obj.subTreeId = this.subTreeId
        }
        if (+this.query.fileType === 1) {
          obj.nodeType = this.nodeType
        }
        let params = {}
        if (['gbq5', 'gbq6', 'gbq7', 'gbq6jy', 'gbq6xs'].includes(this.suffix)) {
          if (this.previewShare) {
            params = {
              shareToken: obj.shareToken,
              fileId: obj.fileId,
              tableType: obj.tableType,
              projectId: obj.projectId,
              nodeType: this.nodeType
            }
            if (changeType === 'subTree') {
              params.subTreeId = obj.subTreeId
            }
          } else {
            params = obj
          }
        } else {
          params.path = obj.path
          params.projectId = obj.projectId < 0 ? 0 : obj.projectId
          params.tableType = obj.tableType < 0 ? 0 : obj.tableType
          params.workspaceId = obj.workspaceId
        }
        if (params.path) {
          params.path = this.filePath
        }
        // console.log(params)
        let isRecord
        if (this.$route.query.recordedProjectId) {
          isRecord = true
          // params.recordedProjectId = params.projectId
          // params.projectId = this.$route.query.recordedProjectId
        }
        service.preview['preview' + type](params, isRecord).then((data) => {
          this.handleRequest(data, changeType)
        })
      }
    },
    // 2.1 tab 切换
    changeTab (item) {
      this.currentTab = item.value
      this.fetchData('tab')
    },
    // 2.2 树形菜单、子树 节点点击
    treeNodeClick (item, type) {
      this[type + 'Active'] = item.path
      switch (type) {
        case 'tree':
          // this.currentTab = -1
          this.projectId = item.id
          this.nodeType = item.nodeType
          this.fetchData(type)
          break
        case 'subTree':
          this.subTreeId = item.id
          this.fetchData(type)
          break
        default:
      }
    },
    // 3. 展开、折叠 表格/树 数据
    switchFold (nowTr, type) {
      if (type) {
        let hide = nowTr.childrenHide || false
        const reg = new RegExp('^' + nowTr.path + '-')
        this[type + 'Data'].forEach((item, idx) => {
          if (item.id === nowTr.id) {
            this.$set(this[type + 'Data'][idx], 'childrenHide', !hide)
          }
          if (reg.test(item.path)) {
            if (type === 'table') {
              let show = hide
              if (show && JSON.stringify(this.showListFilterByColor) !== '{}' && !this.showListFilterByColor[item.id]) {
                show = false
              }
              this.$set(this[type + 'Data'][idx], 'show', show)
            } else {
              this.$set(this[type + 'Data'][idx], 'show', hide)
            }
          }
        })
        this['refresh' + capitalize(type) + 'Index']++
      }
    },
    // 4. 颜色过滤
    colorFilter (arr) {
      this.scrollTop = 0
      this.scrollLeft = 0
      const showListFilterByColor = {}
      const showAll = arr.length === 0 // || arr.length === this.colorList.length
      this.colorSelectedArr = arr || []
      this.colorSelected = {}
      arr.forEach((color) => {
        this.$set(this.colorSelected, color, true)
      })
      this.tableData.forEach((nowTr, idx) => {
        let show = showAll ? true : this.judgeColor(nowTr)
        if (idx === 0) {
          show = true
        }
        if (!show && nowTr.showByParent) {
          show = true
        }
        this.$set(this.tableData, idx, Object.assign(nowTr, {show, showByParent: false}))
        if (!nowTr.leaf && show) {
          // 显示 子节点
          this.$set(this.tableData, idx, Object.assign(nowTr, {show, showByParent: false, childrenHide: false}))
          this.showChildNode(nowTr.path)
        }
        // 显示父节点
        const pathList = nowTr.path.split('-')
        pathList.pop()
        if (pathList.length && show) {
          this.showParentNode(pathList)
        }
      })
      this.refreshTableIndex++
      let lastShowIndex = 0
      this.tableData.forEach((nowTr, idx) => {
        if (nowTr.show) {
          showListFilterByColor[nowTr.id] = 1
          lastShowIndex = idx
        }
      })
      this.lastShowIndex = lastShowIndex // 给颜色过滤后 最后显示的行 添加下边线
      this.showListFilterByColor = showListFilterByColor
      this.initEvent(true)
    },
    // 4.1 判断 当前行背景色 是否在已选择色值列表中
    judgeColor (nowTr) {
      let show = false
      let trBackgroundColor = ''
      if (nowTr.content && nowTr.content.length && nowTr.content[0].style) {
        const splitArr = nowTr.content[0].style.split('background:')
        if (splitArr[1]) {
          trBackgroundColor = splitArr[1].substring(0, 7)
        }
      }
      if (trBackgroundColor && this.colorSelected[capitalize(trBackgroundColor, false, true)]) {
        show = true
      }
      return show
    },
    // 4.2 颜色过滤时  展示父节点
    showParentNode (pathList) {
      // console.log(pathList)
      const path = pathList.join('-')
      for (let i = 0; i < this.tableData.length; i++) {
        const nowTr = this.tableData[i]
        if (nowTr.path === path) {
          this.$set(this.tableData, i, Object.assign(nowTr, {show: true, childrenHide: false}))
          pathList.pop()
          if (pathList.length) {
            this.showParentNode(pathList)
          }
          break
        }
      }
    },
    // 4.3 颜色过滤时  展示子节点
    showChildNode (parentPath) {
      const reg = new RegExp('^' + parentPath + '-')
      this.tableData.forEach((nowTr, i) => {
        if (reg.test(nowTr.path)) {
          const obj = {showByParent: true}
          if (!nowTr.leaf) {
            obj.childrenHide = false
          }
          this.$set(this.tableData, i, Object.assign(nowTr, obj))
        }
      })
    },
    // 5. td中 鼠标右键
    tdMouseEnter (trIndex, tdIndex, trItem, tdItem) {
      // console.log(trIndex)
      // console.log(tdIndex)
      // console.log(trItem)
      // console.log(tdItem)
      // if (trItem.guid && +tdIndex === +trItem.index) {
      if (trItem.guid && +trItem.index < trItem.content.length) {
        this.remark.row = trIndex
        this.remark.column = tdIndex
        this.remark.guid = trItem.guid
        this.remark.comment = trItem.comment
        if (trItem.content && trItem.content[0]) {
          this.remark.code = trItem.content[0].content || ''
        }
        try {
          this.remark.name = trItem.content[trItem.index].content
        } catch (e) {

        }
        // this.remark.name = tdItem.content || ''
      } else {
        this.remark.row = -1
        this.remark.column = -1
        this.remark.guid = ''
        this.remark.comment = ''
        this.remark.code = ''
        this.remark.name = ''
      }
      const contextMenu = this.$refs.contextMenu
      let zIndex = 500
      if (tdIndex < trItem.fixedTd) {
        zIndex = 800
      }
      if (contextMenu) {
        contextMenu.style.zIndex = zIndex
      }
    },
    // 6. 右键菜单 选择
    remarkHandle (type) {
      if ((this.$route.query.privilege === 'view' || this.$route.query.recordedProjectId) && type !== 'show') {
        return
      }
      switch (type) {
        case 'delete':
          this.updateRemark('')
          break
        default:
          this.remark.type = type
          this.contextMenu.show = -1
          this.refreshRemarkIndex++
          if (type !== 'show') {
            setTimeout(() => {
              // const textarea = document.getElementById('remark_' + this.remark.row + '_' + this.remark.column)
              const textarea = document.getElementById('remark_' + this.remark.row)
              textarea.focus()
            }, 50)
          }
      }
    },
    // 7. 增、删、改 批注
    updateRemark (comment) {
      if (this.remark.pending) return
      this.remark.pending = true
      let query = '?comment=' + encodeURIComponent(comment)
      query += '&guid=' + this.remark.guid
      query += '&path=' + encodeURIComponent(this.query.path)
      query += '&workspaceId=' + this.query.workspaceId
      service.preview.updateRemark(query, {code: this.remark.code || this.remark.guid, name: this.remark.name}).then((data) => {
        const rowData = clone(this.tableData[this.remark.row])
        if (+data.code === 200) {
          rowData.comment = comment
          // rowData.index = this.remark.column
          // console.log(rowData)
          this.$set(this.tableData, this.remark.row, rowData)
          // console.log(this.remark)
          // console.log(this.tableData[this.remark.row])
        } else {
          this.$message.error(data.message)
        }
        this.remark.pending = false
        this.clearRemark()
      }).catch((e) => {
        console.log(e)
        this.remark.pending = false
      })
    },
    // x. 清空数据
    clearData (changeType) {
      if (changeType === undefined || changeType === 'tree') {
        this.currentTab = -1
        this.tabList = []
      }
      if (changeType !== 'subTree') {
        this.subTreeData = []
        this.subTreeActive = ''
        this.subTreeId = ''
      }
      if (changeType === undefined) {
        this.treeData = []
        this.treeActive = ''
      }
      this.tableData = []
      this.colorList = []
      this.colorSelectedArr = []
      this.showListFilterByColor = {}
      this.colorSelected = {}
      this.fixedColumnCount = 0
      this.scrollTop = 0
      this.scrollLeft = 0
      this.lastShowIndex = 0
      this.clearRemark()
    },
    clearRemark () {
      this.contextMenu.show = -1
      // 清空 批注相关
      this.remark.row = -1
      this.remark.column = -1
      this.remark.type = ''
      this.remark.guid = ''
      this.remark.comment = ''
      this.remark.code = ''
      this.remark.name = ''
    }
  },
  watch: {
    'previewFileChange': function () {
      // this.getFileFormation()
      window.location.reload()
    }
  },
  components: {
    TabTitle,
    MultipleSelect
  }
}
</script>
<style lang="less" type="text/less">
  @import "../../assets/less/preview";
</style>
